// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"5a0bdcee","293":"1012f984","453":"99e2b55a","474":"a870a03b","908":"aa560a21"}[chunkId] + ".chunk.js";
};